import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetInfoDeclaracionJuradaGarantiasLaborales = {
  status: number | null;
  statusText: string | null;
};

const useGetInfoDeclaracionJuradaGarantiasLaborales = () => {
  const [loadingGetInfoDeclaracionJuradaGarantiasLaborales, setLoadingGetInfoDeclaracionJuradaGarantiasLaborales] = useState(false);
  const [successGetInfoDeclaracionJuradaGarantiasLaborales, setSuccessGetInfoDeclaracionJuradaGarantiasLaborales] = useState(false);
  const [errorGetInfoDeclaracionJuradaGarantiasLaborales, setErrorGetInfoDeclaracionJuradaGarantiasLaborales] = useState<any>(null);
  const [dataGetInfoDeclaracionJuradaGarantiasLaborales, setDataGetInfoDeclaracionJuradaGarantiasLaborales] = useState<any>(null);

  const [statusGetInfoDeclaracionJuradaGarantiasLaborales, setStatusGetInfoDeclaracionJuradaGarantiasLaborales] =
    useState<StatusGetInfoDeclaracionJuradaGarantiasLaborales>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  const getInfoDeclaracionJuradaGarantiasLaborales = async (
    userId: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetInfoDeclaracionJuradaGarantiasLaborales(true);
    setSuccessGetInfoDeclaracionJuradaGarantiasLaborales(false);
    setErrorGetInfoDeclaracionJuradaGarantiasLaborales(null);

    try {
      const res = await apiRecord.getInfoSolicitudDeclaracionJuradaGarantias(userId);

      setStatusGetInfoDeclaracionJuradaGarantiasLaborales({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessGetInfoDeclaracionJuradaGarantiasLaborales(true);
      setDataGetInfoDeclaracionJuradaGarantiasLaborales(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetInfoDeclaracionJuradaGarantiasLaborales({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorGetInfoDeclaracionJuradaGarantiasLaborales(err);
      console.error("Error en getInfoDeclaracionJuradaGarantiasLaborales:", err);

      throw err;

    } finally {
      setLoadingGetInfoDeclaracionJuradaGarantiasLaborales(false);
    }
  };

  return {
    getInfoDeclaracionJuradaGarantiasLaborales,
    loadingGetInfoDeclaracionJuradaGarantiasLaborales,
    successGetInfoDeclaracionJuradaGarantiasLaborales,
    errorGetInfoDeclaracionJuradaGarantiasLaborales,
    dataGetInfoDeclaracionJuradaGarantiasLaborales,
    statusGetInfoDeclaracionJuradaGarantiasLaborales
  };
};

export default useGetInfoDeclaracionJuradaGarantiasLaborales;
